<template>
    <div>
        <v-row　justify="center" class="mt-16">
            <v-col
                cols="12"
                sm="12"
                md="12"
                >
                <div class="text-center font-weight-bold text-h5">
                    電子契約サービス「DX-Sign」へご登録ありがとうございます。
                </div>
                <div class="text-center mt-3 text-h6">
                    入力いただいたメールアドレスへ本登録用メールをお送りしました。
                </div>
                <div class="text-center text-h6">
                    本登録用メールに記載されているURLと仮パスワードにて本登録処理を完了してください。
                </div>
            </v-col>
        </v-row>
        <v-row　justify="center" class="mt-8">
            <v-col
                cols="12"
                sm="12"
                md="12"
                >
                    <div class="text-center font-weight-bold text-h5">
                        送信先メールアドレス： {{ email }}
                    </div>
                    <div class="text-center mt-3 text-h6">
                        本登録用メールに記載されているURLと仮パスワードにて本登録処理を完了してください。
                    </div>
            </v-col>
        </v-row>
        <v-row　justify="center" class="mt-8">
            <v-col
                cols="12"
                sm="12"
                md="12"
                >
                <div class="text-center font-weight-bold text-h5">
                    ※本登録メールが届かない場合※
                </div>
                <div class="text-center mt-3 text-h6">
                    迷惑メール等に振り分けられていないか念のためご確認ください。
                </div>
                <div class="text-center text-h6">
                    上記記載メールアドレスに誤りがあった場合は、正しいメールアドレスにて
                    再度、新規登録手続きを行ってください。
                </div>
            </v-col>
        </v-row>
        <v-row justify="center" class="mt-8">
            <v-col
                cols="12"
                sm="6"
                md="3"
                >
                <v-alert
                  outlined
                  type="info"
                >
                    ブラウザの「✕」ボタンをクリックしてこの画面を閉じてください
                </v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            email: {
              type: String
            },
        },
    };
</script>
<style scoped>
    .text-h5 {
        font-size: 2rem !important;
    }
    .text-h6 {
        font-size: 1.5rem !important;
    }
</style>